module.exports = __webpack_public_path__ + "static/media/direct-debit.d33bc661.svg";